if (!customElements.get('delivery-info')) {
	class DeliveryInfo extends HTMLElement {
		constructor() {
			super();

			const text = this.querySelector('.js-text');

			const months = window.deliveryLocales.months;

			const deliveryDates = this.getNextSixWorkdays(Date.now());
			const deliveryDate = deliveryDates[deliveryDates.length - 1];
			const deliveryMonth = deliveryDate.getMonth();
			const deliveryText = `${window.deliveryLocales.deliveryOn} ${deliveryDate.getDate()} ${months[deliveryMonth]}`;

			text.innerHTML = deliveryText;
		}

		getNextSixWorkdays(startDate) {
			let date = new Date(startDate);
			let workdays = [];

			while (workdays.length < 4) {
				date.setDate(date.getDate() + 1);

				if (date.getDay() !== 0 && date.getDay() !== 4) {
					workdays.push(new Date(date));
				}
			}

			return workdays;
		}
	}

	customElements.define('delivery-info', DeliveryInfo);
}

